/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component, OnDestroy, OnInit } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { ICONS } from "src/app/core/constants/icons";
import * as ButtonSelectionActions from "../../../../../state/actions/button-click.actions";
import { JACKPOT_MENU_ITEMS } from "src/app/core/constants/menuItems";
import { DialogService } from "src/app/core/services/dialog.service";
import { ButtonsState } from "src/app/state/buttons-state";
import { selectJackpotModuleName } from "src/app/state/reducer/buttons.reducer";

@Component({
  selector: "app-jackpot-tabs",
  templateUrl: "./jackpot-tabs.component.html",
  styleUrl: "./jackpot-tabs.component.scss"
})
export class JackpotTabsComponent implements OnInit, OnDestroy {

  protected JACKPOT = ICONS.HEADER_JACKPOT;
  protected INFO_WHITE = ICONS.INFO_WHITE;
  protected jackpotMenuItems = JACKPOT_MENU_ITEMS;

  private $selectedFreeToPlayModule = this.store.pipe(select(selectJackpotModuleName));
  private moduleNameChangedSubscription: any;
  private selectedModule: string = "";

  constructor(private store: Store<ButtonsState>,
    private dialogService: DialogService) { }


  ngOnInit(): void {
       this.moduleNameChangedSubscription = this.$selectedFreeToPlayModule.subscribe(selectedModule => {
      this.selectedModule = selectedModule;
      this.isButtonSelected(this.selectedModule);
    });
  }

  isButtonSelected(buttonName: string): boolean {
    return buttonName === this.selectedModule;
  }

  openInfoModal() {
    this.dialogService.openConfirmation("", "Skeniraj MaxLoyalty QR kod dobijen uz uplaćen tiket, i učestvuj u izvlačenju već sledećeg Jackpot-a!");
  }

  selectButton(buttonName: string): void {
    this.selectedModule = buttonName;
    this.store.dispatch(ButtonSelectionActions.JACKPOT_MODULE_SELECTED({ button: buttonName }));
  }

  ngOnDestroy(): void {
    this.moduleNameChangedSubscription.unsubscribe();
  }
}